"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentItem = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
const utils_1 = require("@/utils");
require("@/components/common/avatar/avatar");
require("@/components/common/icon-button/icon-button");
require("@/components/common/icon-button/semantics/clear-button");
require("@/components/common/text/semantics/caption");
require("@/components/common/text/text");
let AttachmentItem = class AttachmentItem extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.fileName = '';
        this.fileSize = '';
        this.type = '';
    }
    render() {
        return (0, lit_1.html) `
      <div class="preview">
        <mm-avatar
          shape="square"
          size="80"
          src=${(0, if_defined_js_1.ifDefined)(this.previewUrl)}
          icon=${this.fallbackIconName}
        ></mm-avatar>
        ${this.renderProgress()} ${this.renderRetryButton()}
      </div>
      <mm-caption>${this.fileName}</mm-caption>
      ${this.renderStatus()}
      <mm-clear-button
        aria-label=${this.isUploading ? '업로드 취소' : '삭제'}
        @click=${this.handleRemoveClick}
      ></mm-clear-button>
    `;
    }
    renderProgress() {
        if (!this.isUploading)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <progress
        value=${this.progress ?? 0}
        max="100"
        aria-label=${`${this.fileName} 업로드 진행률`}
      ></progress>
    `;
    }
    renderRetryButton() {
        if (!this.error)
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon-button
        size="small"
        icon=${icon_names_1.ICON_NAMES.RETRY}
        aria-label=${`${this.fileName} 다시 업로드`}
        @click=${this.handleRetryClick}
      ></mm-icon-button>
    `;
    }
    renderStatus() {
        if (this.error) {
            return (0, lit_1.html) `
        <mm-text as="span" size="12" weight="medium" color="danger" role="alert">
          ${this.error}
        </mm-text>
      `;
        }
        if (this.isUploading) {
            return (0, lit_1.html) `
        <mm-caption>업로드 중 ${this.progress}%</mm-caption>
      `;
        }
        return (0, lit_1.html) `
      <mm-caption>${this.fileSize}</mm-caption>
    `;
    }
    get isUploading() {
        return this.progress !== undefined && !this.error;
    }
    get fallbackIconName() {
        return this.type.startsWith('video/') ? icon_names_1.ICON_NAMES.VIDEO : icon_names_1.ICON_NAMES.DOCUMENT;
    }
    handleRemoveClick() {
        (0, utils_1.emit)(this, 'remove');
    }
    handleRetryClick() {
        (0, utils_1.emit)(this, 'retry');
    }
};
AttachmentItem.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      width: var(--size-80);
      gap: var(--space-1);
      position: relative;
    }

    .preview {
      position: relative;
    }

    progress {
      width: calc(100% - var(--space-2) * 2);
      height: var(--space-1);
      border: 0;
      border-radius: var(--radius);
      background-color: var(--background-subtle-color);
      overflow: hidden;
      appearance: none;
      position: absolute;
      bottom: var(--space-2);
      left: var(--space-2);
    }

    progress::-webkit-progress-bar {
      background-color: var(--background-subtle-color);
    }

    progress::-webkit-progress-value {
      background-color: var(--primary-color);
    }

    progress::-moz-progress-bar {
      background-color: var(--primary-color);
    }

    .preview mm-icon-button {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    mm-clear-button {
      position: absolute;
      right: var(--space-1-minus);
      top: var(--space-1-minus);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'file-name' })
], AttachmentItem.prototype, "fileName", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'file-size' })
], AttachmentItem.prototype, "fileSize", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String, attribute: 'preview-url' })
], AttachmentItem.prototype, "previewUrl", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], AttachmentItem.prototype, "type", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], AttachmentItem.prototype, "progress", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], AttachmentItem.prototype, "error", void 0);
AttachmentItem = __decorate([
    (0, decorators_js_1.customElement)('mm-attachment-item')
], AttachmentItem);
exports.AttachmentItem = AttachmentItem;
//# sourceMappingURL=data:application/json;base64,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